import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/system/Box";
import { Grid, Typography, Divider } from "@mui/material";
import { parseAndFormatDate } from "../../../../../utils/dateHelpers";

export default function RateConfirmationModalSidebarItem({ index, stop }) {
  const [schedLate, setSchedLate] = useState("");
  const [schedEarly, setSchedEarly] = useState("");

  useEffect(() => {
    if (stop) {
      setSchedLate(parseAndFormatDate(stop.schedArriveLate, "MM/dd/yy HH:mm"));
      setSchedEarly(parseAndFormatDate(stop.schedArriveEarly, "MM/dd/yy HH:mm"));
    }
  }, [stop]);

  return (
    <Box marginY="20px">
      {stop &&
        <>
          <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "black_solid.20",
            color: "black_solid.80",
            marginBottom: "10px",
            padding: "5px"
          }} >
            <Grid item xs={4}>
              <Typography variant="subhead2" color="primary.60" marginBottom="10px">{stop.stopType} {index}</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body2">{schedEarly} - {schedLate}</Typography>
            </Grid>
          </Box>
          <Grid container spacing={1} color="black_solid.50">
            <Grid item xs={4}>
              <Typography color="black_solid.60">Name</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography>{stop.locationName}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography color="black_solid.60">Address</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography>{stop.address}</Typography>
              <Typography>{stop.cityName} {stop.state} {stop.zip_code}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography color="black_solid.60">Reference #</Typography>
            </Grid>
            <Grid item xs={8}>
              <Box spacing={1}>
                {stop.referenceNumbers && stop.referenceNumbers.length > 0 ? stop.referenceNumbers.map((r, i) => (
                  <Box key={i} display="flex" gap={1} marginBottom="5px">
                    <Grid item xs={2}>
                      <Typography>{r.reference_qual}</Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography>{r.reference_number}</Typography>
                    </Grid>
                  </Box>
                )) : (
                  <Box>
                    <Typography color="black_solid.60">No references found</Typography>
                  </Box>
                )}
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Typography color="black_solid.60">Hot Comments</Typography>
            </Grid>
            <Grid item xs={8}>
              {stop.stopNotes && stop.stopNotes.length > 0 ? stop.stopNotes.map((r, i) => (
                <Box key={i}>
                  <Typography marginBottom="5px">{r.comments}</Typography>
                  {stop.stopNotes.length > i + 1 && <Divider sx={{ marginBottom: "5px" }} />}
                </Box>
              )) : (
                <Box>
                  <Typography color="black_solid.60">No comments found</Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </>
      }
    </Box>
  );
}

RateConfirmationModalSidebarItem.propTypes = {
  index: PropTypes.number,
  stop: PropTypes.object
};